<template>
  <div>
    <!-- <van-nav-bar /> -->
    <van-radio-group v-model="radio1" v-if="teacherList.length > 0">
      <van-cell-group title="选择当前所在的单位：">
        <van-cell
          :title="`${item.schoolName}(${item.position})`"
          :key="item.id"
          clickable
          @click="clickItem(item)"
          v-for="item in teacherList"
        >
          <template #right-icon>
            <van-radio :name="item.id" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>

    <van-radio-group v-model="radio2" v-if="patriarchList.length > 0">
      <van-cell-group title="你要关注哪个孩子的考勤和请假信息，请选择：">
        <van-cell
          :title="`${item.childNames}(${item.schoolName})`"
          :key="item.id"
          clickable
          @click="clickItem(item)"
          v-for="item in patriarchList"
        >
          <template #right-icon>
            <van-radio :name="item.id" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div v-if="this.show && !patriarchList.length && !teacherList.length">
      <van-empty/>
      <div v-if="mobile" class="mobileStyle">
        <span>手机号 {{mobile}} 无身份绑定信息<br/></span>
        <span>如果您是老师，请联系学校管理员<br/></span>
        <span>如果您是家长，请联系学校班主任<br/></span>
        <span>技术支持：0531-87901000</span>
      </div>
      <div v-else class="mobileStyle">
        <span>未绑定手机号<br/></span>
        <span>如果您是老师，请联系学校管理员<br/></span>
        <span>如果您是家长，请联系学校班主任<br/></span>
        <span>技术支持：0531-87901000</span>
      </div>
      <el-button
        v-if="this.$route.params.hrefTo"
        style="width: 140px; margin-left: calc(50% - 70px)"
        @click="goback"
        >返回个人信息</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      selItem: {},
      patriarchList: [],
      teacherList: [],
      mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      radio1: JSON.parse(localStorage.getItem("userInfo")).id,
      radio2: JSON.parse(localStorage.getItem("userInfo")).patriarchUserId,
      show: false,
    };
  },
  computed: {
    // radio1: {
    //   get() {
    //     return this.$store.state.userId;
    //   },
    //   set(value) {
    //     this.$store.commit("setUserId", value.id);
    //     this.$store.commit("setSchoolId", value.schoolId);
    //   },
    // },
    // radio2: {
    //   get() {
    //     return JSON.parse(localStorage.getItem('userInfo')).patriarchUserId
    //   },
    //   set(value) {
    //     console.log('ss', value)
    //     // this.$store.commit('setSchoolId', value)
    //   },
    // },
  },
  mounted() {
    this.getSchoolList();
  },
  methods: {
    goback() {
      history.go(-1);
    },
    clickItem(item) {
      this.selItem = item;
      // if (item.id == this.$store.state.userId) {
      //   return
      // }
      let state = false;
      if (!this.patriarchList.length || !this.teacherList.length) {
        state = true;
      } else {
        let state1 = false,
          state2 = false;
        this.patriarchList.forEach((item) => {
          if (item.id == this.radio2) {
            state1 = true;
          }
        });
        this.teacherList.forEach((item) => {
          if (item.id == this.radio1) {
            state2 = true;
          }
        });
        state = state1 && state2;
      }
      this.identitySwitch(state);
    },
    async getSchoolList() {
      const { code, data } = await this.$https.getSchoolList({
        // userId: this.$store.state.userId,
      });
      console.log("信息", data);
      if (code !== 200) {
        this.list = [];
        return false;
      }
      let obj = {
        13: "老师",
        12: "家长",
        2: "访客",
      };
      // 家长
      this.patriarchList = data.patriarchList.map((item) => {
        item.position = obj[item.personType];
        return item;
      });
      // 老师
      this.teacherList = data.teacherList.map((item) => {
        item.position = obj[item.personType];
        return item;
      });
      this.show = true;
      // 跳转
      // if (data.patriarchList.length == 0 && data.teacherList.length == 0) {
      //   this.$router.push({
      //     path: '/profile',
      //     repalce: true,
      //   })
      // }
    },
    async identitySwitch(state) {
      const { data, code } = await this.$https.identitySwitch({
        openId: JSON.parse(localStorage.getItem("userInfo")).openId,
        userId: this.selItem.id,
        userType: this.selItem.personType == 13 ? "1" : "2",
      });
      // return
      if (code !== 200) {
        return;
      }
      // let uinfo = JSON.parse(localStorage.getItem("userInfo"));

      if (this.selItem.personType == 13) {
        this.radio1 = data.id;
        this.$store.commit("setUserId", data.id);
        this.$store.commit("setSchoolId", data.schoolId);
        // uinfo.id = data.id
        // uinfo.schoolId = data.schoolId
        localStorage.setItem("userInfo", JSON.stringify(data));
        if (this.$route.params.hrefTo) {
          if (state) {
            this.$router.push({
              path: "/naReport",
              repalce: true,
            });
            this.$toast({
              message: "身份切换完成",
              duration: 1000,
            });
            return;
          } else {
            this.$toast({
              message: "请选择家长身份",
              duration: 1000,
            });
            return;
          }
        }
      } else {
        this.radio2 = data.patriarchUserId;
        // uinfo.patriarchUserId = data.patriarchUserId
        // uinfo.patriarchUserId = data.patriarchUserId
        localStorage.setItem("userInfo", JSON.stringify(data));
        if (this.$route.params.hrefTo) {
          if (state) {
            this.$router.push({
              path: "/naReport",
              repalce: true,
            });
            this.$toast({
              message: "身份切换完成",
              duration: 1000,
            });
            return;
          } else {
            this.$toast({
              message: "请选择老师身份",
              duration: 1000,
            });
            return;
          }
        }
      }
      this.$toast("身份切换成功");
    },
    // async updateSchool() {
    //   const { code, data } = await this.$https.updateSchool({
    //     // id: this.$store.state.userId,
    //     id: this.selItem.id,
    //     // schoolId: this.selItem.schoolId,
    //   })
    //   if (code !== 200) {
    //     this.$toast('切换失败')
    //     return false
    //   }
    //   // this.$store.commit('setSchoolId', data.schoolId)
    //   this.radio = data.schoolId
    //   this.$store.commit('setUserId', data.id)
    //   sessionStorage.setItem('token', data.token)
    //   // let uinfo = JSON.parse(sessionStorage.getItem('userInfo'))
    //   // uinfo.personType = data.personType
    //   sessionStorage.setItem('userInfo', JSON.stringify(data))
    //   this.$toast('修改成功')
    // },
  },
};
</script>

<style lang="scss" scoped>
.school-list {
  padding: 1rem;
}
.mobileStyle{
  margin: -5% 15% 8% 15%;
  color: #606266;
  font-size: 0.85rem;
  text-align: center;
}
</style>
